import type { TReviewCountProps } from "../../types";
import * as Comp from "./review-count.styles";

export const ReviewCount = ({
  size = "medium",
  reviewCount,
  testID = "review-count",
  ...props
}: TReviewCountProps) => {
  return (
    <Comp.Root
      size={size}
      numberOfLines={1}
      ellipsizeMode="tail"
      testID={testID}
      {...props}
    >
      (
      {reviewCount.toLocaleString("pt-BR", {
        maximumFractionDigits: 0,
      })}{" "}
      avaliações)
    </Comp.Root>
  );
};
